import { useEpdLcaCustomResultGridData } from 'services/api/queries';
import { LcaCustomResultModel, Option } from 'types/types';
import { PdfH3, PdfTable } from './Styles.styled';
import LcaCustomAdditionalResultsGrid from 'components/v2/compiler/grids/lca-results/custom/LcaCustomAdditionalResultsGrid';
import { CUSTOM_RESULT_KEYS, MODULE_KEYS } from 'constants/constants';
import LcaCustomBiogenicResultsGrid from 'components/v2/compiler/grids/lca-results/custom/LcaCustomBiogenicResultsGrid';
import LcaCustomBestWorstResultsGrid from 'components/v2/compiler/grids/lca-results/custom/LcaCustomBestWorstResultsGrid';

const LCACustomResultSection: React.FC<{
  customResult: LcaCustomResultModel;
  additionalPerformanceResultsTypeLookup: Option[];
  scenariosLookup: Option[];
}> = ({ customResult, additionalPerformanceResultsTypeLookup, scenariosLookup }) => {
  const rows = useEpdLcaCustomResultGridData(customResult.id).data ?? [];

  const hasHeaderContent =
    (customResult.resultType === CUSTOM_RESULT_KEYS.A4C4 && customResult.scenarioId) ||
    (customResult.resultType === CUSTOM_RESULT_KEYS.BEST && customResult.bestCaseProduct) ||
    (customResult.resultType === CUSTOM_RESULT_KEYS.WORST && customResult.worstCaseProduct) ||
    (customResult.resultType && customResult.scenarioDescription);

  const isTableFilled = rows.some((row: any) =>
    MODULE_KEYS.some((key) => row[key] !== null && row[key] !== undefined && row[key] !== '')
  );

  if (!hasHeaderContent && !isTableFilled) {
    return null;
  }

  return (
    <>
      <PdfH3>
        {additionalPerformanceResultsTypeLookup.labelByValue(customResult.resultType) ??
          'Additional environmental performance results'}
      </PdfH3>
      <PdfTable>
        <thead>
          <tr>
            <th style={{ width: '20%' }}></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {customResult.resultType === CUSTOM_RESULT_KEYS.A4C4 && customResult.scenarioId && (
            <tr>
              <td>Additional scenario</td>
              <td>{scenariosLookup.labelByValue(customResult.scenarioId)}</td>
            </tr>
          )}

          {customResult.resultType === CUSTOM_RESULT_KEYS.BEST && customResult.bestCaseProduct && (
            <tr>
              <td>Best-case product</td>
              <td>{customResult.bestCaseProduct}</td>
            </tr>
          )}

          {customResult.resultType === CUSTOM_RESULT_KEYS.WORST && customResult.worstCaseProduct && (
            <tr>
              <td>Worst-case product</td>
              <td>{customResult.worstCaseProduct}</td>
            </tr>
          )}

          {customResult.resultType && customResult.scenarioDescription && (
            <tr>
              <td>Description of the scenario/method</td>
              <td>{customResult.scenarioDescription}</td>
            </tr>
          )}
        </tbody>
      </PdfTable>
      {hasHeaderContent && <br />}
      {[CUSTOM_RESULT_KEYS.A4C4, CUSTOM_RESULT_KEYS.MODELING, CUSTOM_RESULT_KEYS.ELECTRICITY, CUSTOM_RESULT_KEYS.BIOGAS].includes(
        customResult.resultType
      ) &&
        isTableFilled && (
          <LcaCustomAdditionalResultsGrid
            epdVersionId={customResult.epdVersionId}
            customResult={customResult}
            isForPdf
          />
        )}

      {customResult.resultType === CUSTOM_RESULT_KEYS.BIOGENIC && isTableFilled && (
        <LcaCustomBiogenicResultsGrid
          epdVersionId={customResult.epdVersionId}
          customResultId={customResult.id}
          isForPdf
        />
      )}
      {[CUSTOM_RESULT_KEYS.BEST, CUSTOM_RESULT_KEYS.WORST].includes(customResult.resultType) && isTableFilled && (
        <LcaCustomBestWorstResultsGrid
          epdVersionId={customResult.epdVersionId}
          customResultId={customResult.id}
          isForPdf
        />
      )}
      <br />
      <br />
    </>
  );
};

export default LCACustomResultSection;
